import React, { Component } from 'react'
import { AUTH_TOKEN } from '../../constants'
import {Currencies} from '../../enumerations'


class PointsUploadOption extends Component {
  state = {
    point_value: '',
    price: '',
    currency: Currencies.HUF
  }

  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    if(props.pointsUploadOption !== undefined) {
        this.state = { 
            point_value: props.pointsUploadOption.point_value,
            price: props.pointsUploadOption.price,
            currency: props.pointsUploadOption.currency
        };
    }
    this.cleanState   = this.cleanState.bind(this)
  }

  handleChange(e) {
    this.setState({currency: e.target.value})
  }

  cleanState() {
      this.setState({
        point_value: '',
        price: '',
        currency: Currencies.HUF
    })
  }
  
  render() {
    const token = localStorage.getItem(AUTH_TOKEN)

    let pointsUploadOption = this.props.pointsUploadOption !== undefined ? this.props.pointsUploadOption : {id: '', point_value:'', price:'', currency: Currencies.HUF}
    
    let elements = React.Children.toArray(this.props.children)
    let addButton
    let deleteButton
    let updateButton
    if(elements.length === 1)
        addButton = React.cloneElement(elements[0], {state: this.state, cleanState: this.cleanState})
    if(elements.length === 2){
        deleteButton = React.cloneElement(elements[0], {id: this.props.pointsUploadOption.id})
        updateButton = React.cloneElement(elements[1], {id: this.props.pointsUploadOption.id, state: this.state, cleanState: this.cleanState})
    }

    return (
        <tr>
            <td>{pointsUploadOption.id}</td>
            <td>{
                token && !this.props.locked ?
                <input
                value={this.state.point_value}
                onChange={e => this.setState({point_value: e.target.value})}
                type="text"
                placeholder="Cost of Action -/+ Points"
                /> 
                : 
                <div>{pointsUploadOption.point_value}</div> 
            }</td>
            <td>{
                token && !this.props.locked ?
                <input
                value={this.state.price}
                onChange={e => this.setState({price: e.target.value})}
                type="text"
                placeholder="Cost of Action -/+ Points"
                /> 
                : 
                <div>{pointsUploadOption.price}</div> 
            }</td>
            <td>{ 
                token && !this.props.locked ?
                <select value={this.state.currency} 
                onChange={(e) => {this.handleChange(e)}}>{
                    Object.keys(Currencies).map(key => (
                    <option key={key} value={key}>{Currencies[key]}</option>
                    ))
                }</select>
                : 
                <div>{pointsUploadOption.currency}</div> 
            }</td>
            {token && !this.props.locked && this.props.pointsUploadOption === undefined  && addButton !== undefined &&
            <td>{ addButton }</td>}
            {token && !this.props.locked && this.props.pointsUploadOption !== undefined  && updateButton !== undefined &&
            <td>{ updateButton }</td>}
            {token && !this.props.locked && this.props.pointsUploadOption !== undefined  && deleteButton !== undefined &&
            <td>{ deleteButton }</td>}
        </tr>
        )
    } 

}

export default PointsUploadOption